import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import book1 from './Sub-Components/books/book1.jpeg';
import book2 from './Sub-Components/books/book2.jpeg';
import book3 from './Sub-Components/books/book3.jpeg';
import book4 from './Sub-Components/books/book4.jpeg';
import './Developer.css';

const DeveloperPage = () => {

  function handleClick() {
    // Redirect the user to the '/game' URL
    window.location.href = '/';
  }

  function handleClickFeedback () {
    window.open('https://forms.office.com/e/YHLBGBPEzE', '_blank');
  }
  

  return (
    <div className="container">
      <section className="team text-center py-4">
        <div className="container">
          <div className="header my-5">
            <h1>Unser Team kennenlernen</h1>
            <p className="text-muted">Lerne unsere Teammitglieder kennen</p>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/Ulf.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>Ulf Könemann</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/William.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>William Neufeld</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/Daniel.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>Daniel Eckertz</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>
            

            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/dummy.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>Taslima Akter</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/Marcel.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>Marcel Niemeyer</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-2">
              <div className="img-block mb-5">
                <img src="/img/dummy.png" className="img-fluid img-thumbnail rounded-circle" alt="image1" />
                <div className="content mt-2">
                  <h4>Bhavesh Wani</h4>
                  {/* <p className="text-muted">Entwickler</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team text-center py-1">
      <div className="container text-center">
        <div className="row justify-content-center">
          <Row>
            <Col md={8} lg={6} className="mb-3">
              <Button
                style={{ backgroundColor: "#009374", width: "100%", outline: "none", border: "none", fontSize: "1.5rem" }}
                onClick={handleClick}
                className="btn-lg"
              >
                Nochmal spielen
              </Button>
            </Col>
            <Col md={8} lg={6} className="mb-3">
              <Button
                style={{ backgroundColor: "#009374", width: "100%", outline: "none", border: "none", fontSize: "1.5rem" }}
                onClick={handleClickFeedback}
                className="btn-lg"
              >
                Feedback
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </section>


    <section className="team text-center py-4">
  <div className="container">
    <div className="header my-5">
      <h1>References</h1>
    </div>
    <div className="row">

      <div className="col-md-6 col-lg-3">
        <div className="img-block mb-5">
          <a href="https://www.amazon.de/Incose-Systems-Engineering-Handbook/dp/1119814294/ref=asc_df_1119814294/?tag=googshopde-21&linkCode=df0&hvadid=634320238730&hvpos=&hvnetw=g&hvrand=10661051817715632138&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9044182&hvtargid=pla-921805744701&psc=1&mcid=54887bc263f43a6992f16aa407b3d110&th=1&psc=1" target="_blank">
            <img src="/img/book-1.png" className="img-fluid fixed-size-image" alt="Book 1" />
          </a>
        </div>
      </div>

      <div className="col-md-6 col-lg-3">
        <div className="img-block mb-5">
          <a href="https://www.amazon.de/INCOSE-Systems-Engineering-Handbuch-Systemlebenszyklus-Prozesse/dp/3910649025/ref=sr_1_3?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=316AB5OZKDT10&dib=eyJ2IjoiMSJ9.RNWYAhycO6o-ZvQa3AoXpvXHHM4_PvTNvTqACHnoeZ0Oa3OFWRjauYCSMmqsaFwO26e-xcGyd5aQ6ywb6vqrktPbGnwy7V977-pqxqe75LzqL0ctoV7ikVO2sOf4Yp7fRls-E4Hk3EmtRtKA5c2zOHgWo7kZDTaoKUwlY7QckrndbaqAxzyml_RWEokPM1VewtPOSu6m4Apo1nCQt-vInBs6-EWTLNUOLQpE5MomivQ.Due0maN7i0qZhNVJYju5vl3Eu2o_yIJ8b0WtEG8iT04&dib_tag=se&keywords=GfSE+Handbuch&qid=1713368308&sprefix=gfse+handbuch%2Caps%2C92&sr=8-3" target="_blank">
            <img src="/img/book-2.png" className="img-fluid fixed-size-image" alt="Book 2" />
          </a>
        </div>
      </div>

      <div className="col-md-6 col-lg-3">
        <div className="img-block mb-5">
          <a href="https://www.amazon.de/Systems-Engineering-Fundamentals-Reinhard-Haberfellner/dp/303013430X/ref=sr_1_1?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=933GFDV3NVXX&dib=eyJ2IjoiMSJ9.QwYk0ArJZApVfBznz8KTDBEmWgv3Fzl_ApGBH0njBckjxA9cO1poYkDZvGEcHyAph5-52DVVcNDuV2xN1e0kCeaxAhcgJKqrO96exFIACOXrZJ_IcqXUy_eV30_bL6fYE8uLzDLQcXYQmDz-Tz8pGFx_eXoCOzU1ncZ8jIvzEeDKrLMrGPKJdizmUHB6g-0W-0QrChGvGLh7jJwh9D9vM5JKn_055l5yKlFvyoLtmow.axZsGmy8bnABpmIUwAWJPpM8tTd_vsmeumLXpHwFVrQ&dib_tag=se&keywords=systems+engineering+haberfellner&qid=1713368348&sprefix=systems+engineerin+haberfellne%2Caps%2C77&sr=8-1" target="_blank">
            <img src={book3} className="img-fluid fixed-size-image" alt="Book 3" />
          </a>
        </div>
      </div>

      <div className="col-md-6 col-lg-3">
        <div className="img-block mb-5">
          <a href="https://www.amazon.de/Innovationen-M%C3%A4rkte-morgen-Dienstleistungen-Gesch%C3%A4ftsmodellen/dp/3446428240/ref=sr_1_1?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=X7H13XLM0T1A&dib=eyJ2IjoiMSJ9.5Z5uezi7gnnymRoqbniMw8eRuqXvuAWuykB4dtwodELbZmPK71WUDwvQ6IH9klw7DlEKTg0UXbl_HLNmlTePcBHWWZcBI84v2xUl2mQb4BhNy11sd9hitpSE8ds-m-ZOPFnY0pXC05J8LLzYOANOV2aR-HXCYnVLvi3bJmAJH4eTIewfRtHcBMqKmqoz1a-CQgtWsh8MZVYREo4Yvhl0ripAvL1DIBUUGDUqFGceJlA.b7hbShiBLb86dya12OQ9bXGf4kU2FGOIktXaj1j_9nw&dib_tag=se&keywords=Innovationen+m%C3%A4rkte+von+morgen&qid=1713368377&sprefix=innovationen+m%C3%A4rkte+von+morgen%2Caps%2C77&sr=8-1" target="_blank">
            <img src={book4} className="img-fluid fixed-size-image" alt="Book 4" />
          </a>
        </div>
      </div>

    </div>
  </div>
</section>



    </div>
  );
};

export default DeveloperPage;